export const POSITION_UPDATE_THRESHOLD_METERS = 5;
export const GEOCODING_DEBOUNCE_MS = 1000;
export const GET_POS_TIMEOUT = 10000; //10sec
export const CACHED_POS_MAX_AGE = 5 * 60 * 1000; //5min
